import { Routes, RouterModule } from '@angular/router';
import { SuccessComponent } from './shared/success/success.component';
import { AuthGuard } from './utilities/authguard.guard';

const routes: Routes = [
  //url for active event 
  {
    path: '',
    redirectTo: '/plant-a-tree',
    pathMatch: 'full'
  },
  {
    path: 'plant-a-tree',
    loadChildren: () => import('./plant-a-tree/plant-a-tree.module').then(m => m.PlantATreeModule),
   canActivate:[AuthGuard]
  },
  {
    path: 'success',
    component: SuccessComponent,
    //canActivate:[AuthGuard]
  },
  //url for active event 
  {
    path: '**', 
    redirectTo: '/plant-a-tree',
    pathMatch: 'full'
  },
];

export const AppRoutes = RouterModule.forRoot(routes);
